module.exports = __webpack_public_path__ + "img/upload-image.63404d28.svg";